let elLoading = Vue.options.directives.loading
let old_bind = elLoading.bind;
let old_update = elLoading.update;
let old_unbind = elLoading.unbind;

const toggleLoading = (el, binding) => {
  if (binding.modifiers.fullscreen) {
    if (!binding.value) {
      if (dsf.client.info.browser == "IE") {
        window.setTimeout(() => {
          Vue.nextTick(() => {
            if (el?.instance) {
              if (!binding.value) {
                el.instance.visible = false;
                el.instance.$el.style.display = 'none'
              }
            }
          });
        }, 500)
      }
    }
    else {
      if (dsf.client.info.browser == "IE") {
        window.setTimeout(() => {
          Vue.nextTick(() => {
            if (el?.instance) {
              if (!binding.value) {
                el.instance.visible = false;
                el.instance.$el.style.display = 'none'
              }
            }
          });
        }, 500)
      }
    }
  }
};

elLoading.bind = function (el, binding, vnode) {
  old_bind(el, binding, vnode);
  if (binding.value) {
    toggleLoading(el, binding)
  }
}
elLoading.update = function (el, binding) {
  old_update(el, binding);
  if (binding.oldValue !== binding.value) {
    toggleLoading(el, binding)
  }
}
elLoading.unbind = function (el, binding) {
  toggleLoading(el, { value: false, modifiers: binding.modifiers });
  old_unbind(el, binding);
}
